class MegaMenu extends HTMLElement {  
    constructor() {  
        super();  
        this.firstContent = null; // Reference for the first content  
    }  

    connectedCallback() {  
        this.summaryItems = this.querySelectorAll('.unique-mega-content');  

        if (this.summaryItems.length === 0) {  
            console.error('No summary items found.');  
            return;  
        }  

        // Get the first summary item and its associated content  
        this.firstContent = this.querySelector(`.sub-mega-menu[data-id="${this.summaryItems[0].getAttribute('data-id')}"]`);  
        this.init();  
    }  

    init() {  
        this.setupDropdownMenus();  
    }  

    setupDropdownMenus() {  
        this.summaryItems.forEach((summary) => {  
            const dataId = summary.getAttribute('data-id');  
            const content = this.querySelector(`.sub-mega-menu[data-id="${dataId}"]`);  
            
            if (content) {  
                summary.addEventListener('mouseenter', () => {  
                    this.handleMouseEnter(content, summary);  
                });  
            } else {  
                console.warn(`No content found for summary with data-id: ${dataId}`);  
            }  
        }); 
    }  

    handleMouseEnter(content, dataId) {  
        this.hideOtherContents();
        dataId.classList.add('mega_item_active');
        content.classList.add('mega_active');  
    }

    hideOtherContents() {  
        const otherContents = this.querySelectorAll('.sub-mega-menu');  
        const otherSummaries = this.querySelectorAll('.unique-mega-content')
        otherContents.forEach(item => {  
            item.classList.remove('mega_active');  
        });  
        otherSummaries.forEach((item) => {
            item.classList.remove('mega_item_active');
        })
    }  
}  

customElements.define('mega-menu', MegaMenu);